import React, { useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ColumnGroupingTable from "../../../table/ColumnGroupingTable.component";
import { Typography } from "@mui/material";
import { stReceivablesOnBs } from "../responseApi";
import { useHedgeRatioContext } from "../../../../context/HedgeRatioContext"; // 💡 Added import
import { applyFigureFormatting } from "../../../../utils/utils"; // 💡 Added import

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const STReceivablesOnBsTable = ({ setSTReceivablesOnBsTableDatas } = {}) => {
  const { selectedFigureDivisor, selectedDecimalsIn } = useHedgeRatioContext();

  const columns = [
    {
      label: "S/T Receivables on BS",
      children: [
        {
          id: "receivablesName",
          label: "Name",
          minWidth: 140,
        },
        {
          id: "receivablesValue",
          label: "Value",
          minWidth: 140,
          align: "right",
        },
      ],
    },
  ];

  const totalReceivablesValue = useMemo(() => {
    return stReceivablesOnBs.reduce(
      (sum, stReceivable) => sum + stReceivable.receivablesValue,
      0
    );
  }, []);

  const stReceivablesOnBsDataRows = useMemo(() => {
    return stReceivablesOnBs?.map(({ receivablesName, receivablesValue }) => ({
      receivablesName,
      receivablesValue: applyFigureFormatting(
        receivablesValue,
        selectedFigureDivisor,
        selectedDecimalsIn
      ),
      minWidth: 120,
      align: "left",
    }));
  }, [selectedFigureDivisor, selectedDecimalsIn]);

  const totalSTReceivablesRow = useMemo(() => {
    return {
      receivablesName: "S/T Receivables",
      receivablesValue: applyFigureFormatting(
        totalReceivablesValue,
        selectedFigureDivisor,
        selectedDecimalsIn
      ),
      minWidth: 120,
      align: "left",
      cellStyles: {
        fontWeight: "bold",
        backgroundColor: "#F5F5F5",
        borderTop: "1px solid #000000",
        borderBottom: "1px solid #000000",
      },
    };
  }, [totalReceivablesValue, selectedFigureDivisor, selectedDecimalsIn]);

  const datas = useMemo(() => {
    return stReceivablesOnBsDataRows
      ? [...stReceivablesOnBsDataRows, totalSTReceivablesRow]
      : [totalSTReceivablesRow];
  }, [stReceivablesOnBsDataRows, totalSTReceivablesRow]);

  useEffect(() => {
    setSTReceivablesOnBsTableDatas(datas);
  }, [datas, setSTReceivablesOnBsTableDatas]);

  return (
    <Grid container spacing={2} sx={{ marginBottom: 0 }}>
      <Grid item xs={12} md={12} lg={12}>
        {!stReceivablesOnBs ? (
          <Item>
            <Typography
              variant="p"
              component="p"
              sx={{
                color: "#adadad",
                minHeight: "250px",
              }}
            >
              There was an error in fetching the data. Please try again later.
            </Typography>
          </Item>
        ) : !stReceivablesOnBs?.length ? (
          <Item>
            <Typography
              variant="p"
              component="p"
              sx={{
                color: "#adadad",
                minHeight: "250px",
              }}
            >
              No data available for the selected filters.
            </Typography>
          </Item>
        ) : (
          // ST Receivables on BS Table
          <ColumnGroupingTable
            columns={columns}
            datas={datas}
            loading={false}
            disablePagination={true}
            applyThousandsSeparator={true}
            tableHeight={280}
            hideChildRowHeader
          />
        )}
      </Grid>
    </Grid>
  );
};

export default STReceivablesOnBsTable;
